import { render, staticRenderFns } from "./blurb-for-appointment.html?vue&type=template&id=71fe291c&scoped=true&external"
import script from "./blurb-for-appointment.js?vue&type=script&lang=js&external"
export * from "./blurb-for-appointment.js?vue&type=script&lang=js&external"
import style0 from "./blurb-for-appointment.scss?vue&type=style&index=0&id=71fe291c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe291c",
  null
  
)

export default component.exports